export const PRICE_AVAILABILITY_ATTRIBUTE_ID = 'partNumber';
